export default __webpack_public_path__ + "static/media/789-doc-p3.2c82b0d9.jpg";